(function () {
  function initialize() {
    const original = document.querySelector('.product-form__buttons-checkout');
    if (!original) return;

    // Clone and insert sticky version
    const sticky = original.cloneNode(true);
    sticky.classList.add('sticky-checkout-button');
    document.body.appendChild(sticky);

    const origAdd = original.querySelector('button.wvr03-atc[name="add"]');
    const stickyAdd = sticky.querySelector('button.wvr03-atc[name="add"]');

    if (stickyAdd && origAdd) {
      // Make sure sticky button is visible
      stickyAdd.removeAttribute('style');

      // Forward sticky click to real button
      stickyAdd.addEventListener('click', function (e) {
        e.preventDefault();
        origAdd.click();
      });

      // Keep sticky button's contents synced with original
      const observer = new MutationObserver(function () {
        stickyAdd.innerHTML = origAdd.innerHTML;
      });
      observer.observe(origAdd, {
        childList: true,
        subtree: true,
        characterData: true
      });

      // Sync immediately
      stickyAdd.innerHTML = origAdd.innerHTML;
    }

    // Show sticky only when original is out of view on mobile
    function toggleSticky() {
      if (window.innerWidth > 767) {
        sticky.classList.remove('show');
        return;
      }

      const rect = original.getBoundingClientRect();
      const outOfView = (rect.top > window.innerHeight) || (rect.bottom < 0);
      sticky.classList.toggle('show', outOfView);
    }

    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
    toggleSticky();
  }

  if (document.readyState !== 'loading') {
    initialize();
  } else {
    document.addEventListener('DOMContentLoaded', initialize);
  }
})();